import { render, staticRenderFns } from "./TableInputPhone.vue?vue&type=template&id=020b7d42&scoped=true"
import script from "./TableInputPhone.vue?vue&type=script&lang=js"
export * from "./TableInputPhone.vue?vue&type=script&lang=js"
import style1 from "./TableInputPhone.vue?vue&type=style&index=1&id=020b7d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b7d42",
  null
  
)

export default component.exports